import { Controller } from "stimulus";

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget;
    const card = button.parentElement;
    const className = button.dataset.openClass;
    const open = !card.classList.contains(className);
    card.classList.toggle(className, open);
    button.setAttribute("aria-expanded", open ? "true" : "false");
  }
}
